/** Registro único de tours: Estudo (studyTours) + Biblioteca, Comunidade e Pessoal (appTours) + seções de /settings. */
import { STUDY_TOURS, StudyTourKey, StudyTourDef } from './studyTours';
import { APP_TOURS, AppTourKey } from './appTours';
import { SETTINGS_TOURS, SettingsTourKey } from './settingsTours';

export type TourKey = StudyTourKey | AppTourKey | SettingsTourKey;
export const ALL_TOURS: Record<TourKey, StudyTourDef> = { ...STUDY_TOURS, ...APP_TOURS, ...SETTINGS_TOURS };
